import { AdvisorInformationTaskEditor } from './AdvisorInformationTaskEditor'

export const AdvisorInformationFeatureMap = {
  traitId: 'advisorInformation' as const,
  TaskEditor: AdvisorInformationTaskEditor,
}
